import { render } from "./PrStoryRequest.vue?vue&type=template&id=acf40b76"
import script from "./PrStoryRequest.vue?vue&type=script&lang=js"
export * from "./PrStoryRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__